import CommonPage from './commonPage.vue'
export default CommonPage